class NewMegamenu extends HTMLElement {
  constructor() {
    super();
    this.navLinks = this.querySelectorAll(".new-megamenu__nav-link");
    this.dropdownWrapper = this.querySelector(
      ".new-megamenu__dropdown-wrapper",
    );
    this.dropdowns = this.querySelectorAll(".new-megamenu__dropdown");
    this.state = false;

    this.navLinks.forEach((link, index) => {
      const clickAction = () => {
        if (link.hasAttribute("data-has-dropdown")) {
          if (!this.state) {
            this.open(link, index);
            this.state = true;
          } else {
            this.close();
          }
        } else {
          this.fireEvent(link);
        }
      };

      link.addEventListener("click", () => {
        clickAction();
      });

      link.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          clickAction();
        }
      });

      link.addEventListener("mouseover", () => {
        if (link.hasAttribute("data-has-dropdown") && this.state) {
          this.open(link, index);
        }
      });
    });

    this.dropdownWrapper.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-opened")) {
        this.close();
      }
    });

    this.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-opened")) {
        this.close();
      }
    });
  }

  open(link, index) {
    link.setAttribute("aria-expanded", "true");
    this.navLinks.forEach((l) => l.setAttribute("data-active", "false"));
    this.dropdowns.forEach((drop) => drop.setAttribute("data-active", "false"));
    this.dropdownWrapper.setAttribute("data-active", "true");
    this.dropdowns[index].setAttribute("data-active", "true");
    link.setAttribute("data-active", "true");
    this.fireEvent(link);
    setTimeout(() => {
      this.dropdowns[index].focus();
    }, 200);
  }

  fireEvent(link) {
    fireCustomGA4Event("click_main_navigation", {
      navigation_title: link.dataset.ga4EventNavTitle,
    });
  }

  close() {
    const activeNavLink = Array.from(this.navLinks).find(
      (link) => link.dataset.active === "true",
    );
    activeNavLink?.setAttribute("aria-expanded", false);
    this.dropdownWrapper.setAttribute("data-active", "false");
    this.navLinks.forEach((l) => l.setAttribute("data-active", "false"));
    this.state = false;
  }
}

customElements.define("new-megamenu", NewMegamenu);
